import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


const DynamicWord = () => {
  const words = ["intelligent", "efficace", "moderne", "élégant"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex(i => (i + 1) % words.length), 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <span key={index} className="dynamic-word" aria-hidden="true">
      {words[index]}
    </span>
  );
};


const AboutUs = () => (
  <>
    {/* 3 pillars / features */}
    <section id="features" className="section features">
      <div className="container">
        <h2>
          Fidéliser n’a jamais été aussi{' '}
          <DynamicWord />
        </h2>
      </div>

      <div className="container features__grid">
        <article className="features__item">
          <div className="features__icon" aria-hidden="true">
            {/* phone icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="2" width="12" height="20" rx="3" />
              <circle cx="12" cy="18" r="1.2" fill="currentColor"/>
            </svg>
          </div>
          <h3>Toujours à portée</h3>
          <p>Plus de cartes papier oubliées ou perdues.</p>
        </article>

        <article className="features__item">
          <div className="features__icon" aria-hidden="true">
            {/* star icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3.5l2.9 5.88 6.5.95-4.7 4.58 1.1 6.49L12 18.8 6.2 21.4l1.1-6.49L2.6 10.3l6.5-.95L12 3.5z" />
            </svg>
          </div>
          <h3>Simple & séduisant</h3>
          <p>Un design pensé pour être utilisé tous les jours.</p>
        </article>

        <article className="features__item">
          <div className="features__icon" aria-hidden="true">
            {/* chart icon */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="10" width="4" height="10" rx="1" />
              <rect x="10" y="6" width="4" height="14" rx="1" />
              <rect x="17" y="3" width="4" height="17" rx="1" />
            </svg>
          </div>
          <h3>Un outil puissant</h3>
          <p>Données en temps réel pour mieux comprendre vos clients.</p>
        </article>
      </div>
    </section>
    {/* Experience section */}
    <section id="experience" className="section experience">
      <div className="container grid-2">
        <div className="experience__copy">
          <h2>Un geste. Un tampon. Une récompense.</h2>
          <p>Réductions, gratuités, cadeaux… toujours accessibles.</p>
        </div>
        <div className="experience__media hiwb__media">
          <img
            src="/images/exp.jpg"
            alt="Client validant un tampon chez un commerçant via l'application"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
    {/* Business benefits */}
    <section id="business" className="section business">
      <div className="container">
        <h2>Passez à la vitesse supérieure.</h2>
        <ul className="business__benefits">
          <li className="business__benefit">
            <div className="business__icon" aria-hidden="true">
              {/* shield icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22S3 18 3 12V5l9-4 9 4v7c0 6-9 10-9 10z" />
              </svg>
            </div>
            <span>Accédez à des données fiables et sécurisées</span>
          </li>
          <li className="business__benefit">
            <div className="business__icon" aria-hidden="true">
              {/* phone icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="2" width="12" height="20" rx="3" />
                <circle cx="12" cy="18" r="1.2" fill="currentColor"/>
              </svg>
            </div>
            <span>Communiquez au bon moment avec vos clients</span>
          </li>
          <li className="business__benefit">
            <div className="business__icon" aria-hidden="true">
              {/* trending up icon */}
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                <polyline points="17 6 23 6 23 12" />
              </svg>
            </div>
            <span>Boostez vos ventes grâce à la fidélité intelligente</span>
          </li>
        </ul>
      </div>
    </section>
    {/* Final CTA */}
    <section id="cta" className="section cta">
      <div className="container cta__card">
        <h2>Carte Verte. Fidélisez autrement.</h2>
        <Link
                        to="/signup"
                        className="btn btn--inverted"
                        
                      >
                        Adhérer maintenant
                      </Link>
      </div>
    </section>

    
  </>
);

export default AboutUs;
